<template>
	<RouterLink v-if="content.flexLayout === 'internal-link-repeatable'" :to="content.link"
		class="--top button" v-reveal>
		{{ content.label }}
	</RouterLink>
	<a v-else :href="content.link" target="_blank" class="button --top" v-reveal>
		<Icon v-if="content.flexLayout === 'video-link-repeatable'" id="play" />
		{{ content.label }}
	</a>
</template>

<script>
import { HasContentMixin } from '@/mixins'

export default {
	name: 'InternalExternalLink',
	mixins: [HasContentMixin]
}
</script>